import React, { useEffect, useState } from "react";
import { Button, Input, Modal, Radio, Image, Checkbox } from "antd";
import "./index.scss"; // Import your CSS file for styling
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { ControlOutlined } from "@ant-design/icons";
import placementOfficer from "../../../api/placementOfficer";
import { getRequest, postRequest } from "../../../api/http";
import { LoadingView } from "../../common";
import ErrorIcon from "../../../assets/images/icons/Pagenotfound.svg";
import toastr from "toastr";
import femaleicon from "../../../assets/images/icons/individualFemale.svg";
import maleicon from "../../../assets/images/icons/registerAsIndividual.svg";

function StudentList({ eventId }) {
  const navigate = useNavigate(); // Initialize useNavigate
  const { Search } = Input;
  const [filterValue, setFilterValue] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // New state for confirmation modal
  const [approvalStatus, setApprovalStatus] = useState("all");
  const [studentData, setStudentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [actionType, setActionType] = useState("");

  const showModal = () => {
    setModalVisible(true);
  };

  const handleOk = (value) => {
    if (value === "all") {
      setFilterValue("");
    } else {
      setFilterValue(value.toUpperCase());
    }
    setApprovalStatus(value);
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const onSearch = async (value) => {
    setSearchValue(value);
  };

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const response = await getRequest(
        placementOfficer.getRegisteredStudents(
          eventId,
          searchValue,
          filterValue
        )
      );
      setStudentData(response.content);
      // Remove selected IDs that are no longer pending
      setSelectedStudents((prev) =>
        prev.filter((id) =>
          response.content.some(
            (stu) => stu.id === id && stu.membershipStatus === "REQUEST"
          )
        )
      );
    } catch (error) {
      // Handle error
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, [searchValue, filterValue]);

  const handleApproval = async (status) => {
    setActionType(status); // Set the action type for confirmation
    setConfirmModalVisible(true); // Show the confirmation modal
  };

  const handleSingleRejection = async (id, status) => {
    setActionType(status); // Set the action type for confirmation
    setSelectedStudents([id]); // Select the single student for rejection
    setConfirmModalVisible(true); // Show the confirmation modal
  };

  const confirmAction = async () => {
    const data = {
      userId: selectedStudents,
      status: actionType,
    };
    try {
      await postRequest(placementOfficer.ApproveStudent(eventId), data);
      const successMessage =
        actionType === "APPROVE"
          ? "The student has been Approved Successfully"
          : "The student has beenRejected Successfully";
      toastr.success(successMessage);
      fetchStudents();
    } catch (error) {
      // Handle error
      console.error("Error updating student status:", error);
    } finally {
      setConfirmModalVisible(false);
      setSelectedStudents([]);
    }
  };

  const toggleSelectStudent = (studentId) => {
    setSelectedStudents((prevSelected) => {
      if (prevSelected.includes(studentId)) {
        return prevSelected.filter((id) => id !== studentId);
      } else {
        return [...prevSelected, studentId];
      }
    });
  };
  const hasPendingStudents = studentData.some(
    (student) => student.membershipStatus === "REQUEST"
  );

  if (loading) return <LoadingView />;

  // Function to handle click on "Approve" or "Reject" button
  const handleAction = (status) => {
    if (selectedStudents.length > 0) {
      // If at least one student is selected, handle the action
      if (status === "REJECT") {
        handleApproval("REJECT");
      } else if (status === "APPROVE") {
        handleApproval("APPROVE");
      }
    } else {
      // If no student is selected, show a message or perform any other action
      toastr.error("Please select at least one student");
    }
  };

  return (
    <div className="studentList">
      <div className="searchRow studentTableSearch">
        <Search
          allowClear
          placeholder={`Find students`}
          onSearch={onSearch}
          enterButton
        />
        <Button
          icon={<ControlOutlined />}
          onClick={showModal}
          className="verficationSearchButton"
          type="primary"
        ></Button>
      </div>
      <div className="approval">
        {hasPendingStudents && (
          <>
            <Button
              type="primary"
              className="button"
              onClick={() => handleAction("REJECT")}
            >
              Reject
            </Button>
            <Button
              type="primary"
              className="button"
              onClick={() => handleAction("APPROVE")}
            >
              Approve
            </Button>
          </>
        )}
      </div>

      {studentData.length > 0 ? (
        studentData.map((student) => (
          <div key={student.id} className="card-long">
            <div style={{ display: "flex", alignItems: "center" }}>
              {student.membershipStatus === "REQUEST" && (
                <div
                  className="checkbox"
                  onClick={() => toggleSelectStudent(student.id)}
                >
                  <Checkbox checked={selectedStudents.includes(student.id)} />
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  marginLeft: 10,
                  cursor: "pointer",
                }}
                onClick={() =>
                  navigate(`/phistory/${student.id}`, { state: { eventId } })
                }
              >
                <div className="card">
                  <img
                    src={
                      student.profileUrl ||
                      (student.gender === "female" ? femaleicon : maleicon)
                    }
                    alt="Profile"
                    width={40}
                    height={40}
                  />
                </div>
                <div className="jobsHead">
                  <div className="jobsHeadCol">
                    <h3>{student.name}</h3>
                    <ul>
                      <li>
                        <span className="JobInfo">
                          <span className="infoNameType">Phone</span>
                          <span className="infoNameValue">{student.phone}</span>
                        </span>
                      </li>
                      <li>
                        <span className="JobInfo">
                          <span className="infoNameType">Email</span>
                          <span className="infoNameValue">{student.email}</span>
                        </span>
                      </li>
                      <li>
                        <span className="JobInfo">
                          <span className="infoNameType">College</span>
                          <span className="infoNameValue">
                            {student?.collegeName}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {student.membershipStatus === "APPROVE" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div className="approved">Approved</div>
                <div className="approval">
                  <Button
                    type="primary"
                    className="button"
                    onClick={() => handleSingleRejection(student.id, "REJECT")}
                  >
                    Reject
                  </Button>
                </div>
              </div>
            ) : student.membershipStatus === "REJECT" ? (
              <div className="rejected">Rejected</div>
            ) : (
              <div className="requested">Requested</div>
            )}
          </div>
        ))
      ) : (
        <div className="errorMsg">
          <Image src={ErrorIcon} preview={false} />
          <h4>No Registered students</h4>
        </div>
      )}

      {/* <div className="paginationRow">
        <Pagination current={currentPage} pageSize={20} total={studentData.length} />
      </div> */}

      {/* Confirmation Modal */}
      <Modal
        title={`Confirmation`}
        visible={confirmModalVisible}
        // onOk={confirmAction}
        onCancel={() => setConfirmModalVisible(false)}
        footer={[
          <Button
            key="no"
            onClick={() => setConfirmModalVisible(false)}
            style={{
              borderRadius: "7px",
              minWidth: "100px",
              height: "auto",
              fontSize: "16px",
              fontWeight: "400",
            }}
          >
            No
          </Button>,
          <Button key="yes" type="primary" onClick={confirmAction}>
            Yes
          </Button>,
        ]}
      >
        <p>Are you sure you want to {actionType.toLowerCase()}?</p>
      </Modal>

      <Modal
        title="Filters"
        visible={modalVisible}
        onOk={() => handleOk(approvalStatus)}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => handleOk(approvalStatus)}
          >
            Ok
          </Button>,
        ]}
      >
        <Radio.Group
          onChange={(e) => setApprovalStatus(e.target.value)}
          value={approvalStatus}
        >
          <Radio value="all">All</Radio>
          <Radio value="approve">Approved</Radio>
          <Radio value="reject">Rejected</Radio>
          <Radio value="request">Pending</Radio>
        </Radio.Group>
      </Modal>
    </div>
  );
}

export default StudentList;
